import { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import ttt from './initializedTtt';

class PageviewTracker extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location === prevProps.location) {
      return;
    }

    this.track();
  }

  componentDidMount() {
    this.track();
  }

  track() {
    const propChannel = 'wbm/Welcome';

    const { pageName, contextData } = this.props;

    ttt.pageview(propChannel, pageName, contextData);
  }

  render() {
    return null;
  }
}

PageviewTracker.propTypes = {
  pageName: PropTypes.string,
  location: PropTypes.shape({ pathname: PropTypes.string }),
  contextData: PropTypes.any,
};

export default withRouter(PageviewTracker);
